
export default {
  // General
  save: "Save",
  cancel: "Cancel",
  loading: "Loading...",
  success: "Success",
  error: "Error",
  close: "Close",
  back: "Back",
  next: "Next",
  submit: "Submit",
  done: "Done",
  noData: "No data",
  confirm: "Confirm",
  delete: "Delete",
  edit: "Edit",
  copy: "Copy",
  copied: "Copied",
  required: "Required",
  optional: "Optional",
  
  // Drafts
  loadingDrafts: "Loading drafts...",
  noDrafts: "No Drafts",
  noDraftsFound: "No drafts found",
  draftDeleted: "Draft deleted",
  draftDeletedSuccess: "Draft deleted successfully",
  draftSaved: "Draft saved",
  errorDeletingDraft: "Error deleting draft",
  problemDeletingDraft: "There was a problem deleting the draft",
  errorLoadingDrafts: "Error loading drafts",
  confirmDeleteDraft: "Are you sure you want to delete this draft?",
  lastEdited: "Last edited",
  viewAllDrafts: "View all drafts",

  // Auth
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  login: "Login",
  register: "Register",
  logout: "Logout",
  username: "Username",
  enterEmail: "Enter your email",
  enterPassword: "Enter your password",
  enterUsername: "Enter your username",
  loginDesc: "Sign in to your account to continue",
  createAccountDesc: "Create a new account to get started",
  alreadyHaveAccount: "Already have an account?",
  dontHaveAccount: "Don't have an account?",
  authRequired: "Authentication Required",
  loginToContinue: "Please login to continue",
  forgotPassword: "Forgot your password?",
  resetPassword: "Reset Password",
  sendResetLink: "Send Reset Link",
  resetPasswordDesc: "Enter your email and we'll send you a password reset link",
  verifying: "Verifying...",
  verificationCode: "Verification Code",
  enterVerificationCode: "Enter 6-digit verification code",
  enterVerificationCodeDesc: "Enter the 6-digit verification code that was sent to your email address.",
  verifyEmail: "Verify Email",
  verifyEmailDesc: "Enter the verification code sent to your email",
  verificationEmailSentTo: "Verification code sent to",
  verifyCode: "Verify Code",
  backToLogin: "Back to Login",
  resendCode: "Resend Code",
  passwordStrength: "Password Strength",
  weak: "Weak",
  moderate: "Moderate",
  strong: "Strong",
  "passwordCriteria.minLength": "At least 8 characters",
  "passwordCriteria.uppercase": "One uppercase letter",
  "passwordCriteria.lowercase": "One lowercase letter",
  "passwordCriteria.number": "One number",
  "passwordCriteria.special": "One special character",
  passwordsDoNotMatch: "Passwords do not match",
  passwordTooWeak: "Password Too Weak",

  // Navigation
  home: "Home",
  about: "About",
  contactUs: "Contact Us",
  services: "Services",
  blog: "Blog",
  pricing: "Pricing",
  terms: "Terms",
  privacy: "Privacy",
  faq: "FAQ",
  ourPartners: "Our Partners",
  influencers: "Influencers",
  campaignCreator: "Campaign Creator (DOOH)",
  clientDashboard: "Client Dashboard",
  
  // Status
  404: "Not Found",
  500: "Server Error",
  noResults: "No results",
  
  // Selection
  selectAll: "Select All",
  selectNone: "Select None",
  selected: "Selected",
  clear: "Clear",
  
  // Date related
  today: "Today",
  yesterday: "Yesterday",
  tomorrow: "Tomorrow",
  thisWeek: "This Week",
  lastWeek: "Last Week",
  nextWeek: "Next Week",
  thisMonth: "This Month",
  lastMonth: "Last Month",
  nextMonth: "Next Month",
  thisYear: "This Year",
  lastYear: "Last Year",
  nextYear: "Next Year",

  // Common UI text
  forInquiries: "For inquiries",
  contactUsLink: "Contact us",
} as const;
